import Header from "./Header";
import Footer from "./Footer";
import "../../assets/css/login.css";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function MainLayout() {
  const { isAuthenticated, loading } = useAuth();

  if (!loading && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="main-page-container">
      <Header />
      <div className="hero-form-box modal-glass">        
          <div className="modal-body justify-content-center text-center">
            <div className="mb-6">              
              <h1 className="hero-title">NAI - Movimentação</h1>
            </div>
          </div>        
      </div>
      <Footer />
    </div>
  );
}

export default MainLayout;